'use client';
/*
 * Documentation:
 * Logo Arbitralis — https://app.subframe.com/6fc7f5fbb098/library?component=Logo+Arbitralis_caf8fe92-8048-478c-ad85-5dd17acaa651
 */

import React from 'react';
import * as SubframeUtils from '../utils';

interface LogoArbitralisRootProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'option-1' | 'branco';
  className?: string;
}

const LogoArbitralisRoot = React.forwardRef<HTMLDivElement, LogoArbitralisRootProps>(
  function LogoArbitralisRoot(
    { variant = 'option-1', className, ...otherProps }: LogoArbitralisRootProps,
    ref,
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          'group/caf8fe92 flex flex-col items-start gap-2',
          className,
        )}
        ref={ref}
        {...otherProps}
      >
        <img
          className="flex-none"
          src={
            variant === 'branco'
              ? 'https://res.cloudinary.com/subframe/image/upload/v1764367732/uploads/31111/kh00h4qslerspl1jnnbn.svg'
              : 'https://res.cloudinary.com/subframe/image/upload/v1763213080/uploads/31111/iba8kbdv6v9adhdfywle.svg'
          }
        />
      </div>
    );
  },
);

export const LogoArbitralis = LogoArbitralisRoot;
